import { Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
	selector: 'cv-users-info',
	templateUrl: './users-info.component.html',
	styleUrls: ['./users-info.component.scss'],
	host: {
		class: 'd-inline-flex align-items-center position-relative'
	}
})
export class UsersInfoComponent {
	@Input() orderUsers: any;
	@ViewChild('usersBoxBtn', { static: false }) usersBoxBtn: ElementRef;
	@ViewChild('usersBox', { static: false }) usersBox: ElementRef;

	clickListener: any;

	constructor(private renderer: Renderer2) {}

	/**
	 * open users box
	 */
	toggleUsersBox(): void {
		const { nativeElement } = this.usersBoxBtn;
		const { nativeElement: el } = this.usersBox;
		if (this.usersBoxBtn && el.style.display !== 'block') {
			const top = nativeElement.offsetTop + nativeElement.offsetHeight;
			this.renderer.setStyle(el, 'top', `${top + 5}px`);
			this.renderer.setStyle(el, 'display', 'block');
			this.registerBoxClickListener();
		} else {
			this.renderer.setStyle(el, 'display', 'none');
			if (this.clickListener) {
				this.clickListener();
			}
		}
	}

	/**
	 * Register the Click listener to trigger the open/close event of active users button panel.
	 */
	registerBoxClickListener(): void {
		setTimeout(() => {
			this.clickListener = this.renderer.listen('document', 'click', (event) => {
				const targetElement = event.target;
				const el = this.usersBox?.nativeElement;
				if (el) {
					const clickedOutside = !el.contains(targetElement);
					if (clickedOutside) {
						this.renderer.setStyle(el, 'display', 'none');
						this.clickListener();
					}
				}
			});
		}, 100);
	}
}
